module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "container",
    attrs: {
      "id": "summary"
    }
  }, [_c('div', {
    staticClass: "segment box"
  }, [_c('h1', {
    staticClass: "title is-uppercase has-text-centered"
  }, [_vm._v("Turnovers")]), _vm._v(" "), _c('div', {
    staticClass: "small-box"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-half is-offset-one-quarter"
  }, [_c('h2', {
    staticClass: "subtitle has-text-centered"
  }, [_vm._v("Game Totals")]), _vm._v(" "), _c('chart', {
    ref: "apex_to_chart",
    attrs: {
      "width": "125%",
      "type": "bar",
      "options": _vm.apex_to_options,
      "series": _vm.apex_to_series
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-half is-offset-one-quarter"
  }, [_c('h2', {
    staticClass: "subtitle has-text-centered"
  }, [_vm._v("Powerplay")]), _vm._v(" "), _c('chart', {
    ref: "apex_to_pp_chart",
    attrs: {
      "type": "bar",
      "options": _vm.apex_to_options,
      "series": _vm.apex_to_pp_series
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "subtitle has-text-centered"
  }, [_vm._v("Short Handed - Clearances")]), _vm._v(" "), _c('chart', {
    ref: "apex_to_sh_chart",
    attrs: {
      "type": "bar",
      "options": _vm.apex_to_options,
      "series": _vm.apex_to_sh_series
    }
  })], 1)])]), _vm._v(" "), _c('div', [_c('sort-table', {
    attrs: {
      "endpoint": "https://devilsapi.roblutken.com/api/app/turnovers-per-period",
      "postData": [{
        team_id: 1,
        game_id: this.gameId
      }],
      "selectedData": [{
          title: 'player',
          prop: 'player'
        },
        {
          title: 'P1 Total',
          prop: 'to_p1'
        },
        {
          title: 'P1 OZ',
          prop: 'to_p1_oz'
        },
        {
          title: 'P1 NZ',
          prop: 'to_p1_nz'
        },
        {
          title: 'P1 DZ',
          prop: 'to_p1_dz'
        },
        {
          title: 'P2 Total',
          prop: 'to_p2'
        },
        {
          title: 'P2 OZ',
          prop: 'to_p2_oz'
        },
        {
          title: 'P2 NZ',
          prop: 'to_p2_nz'
        },
        {
          title: 'P2 DZ',
          prop: 'to_p2_dz'
        },
        {
          title: 'P3 Total',
          prop: 'to_p3'
        },
        {
          title: 'P3 OZ',
          prop: 'to_p3_oz'
        },
        {
          title: 'P3 NZ',
          prop: 'to_p3_nz'
        },
        {
          title: 'P3 DZ',
          prop: 'to_p3_dz'
        },
        {
          title: 'P4 Total',
          prop: 'to_ot'
        },
        {
          title: 'Total',
          prop: 'to_total'
        } ]
    },
    on: {
      "dataLoaded": _vm.gameDataLoaded
    }
  })], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-637166da"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/views/stats/match-turnovers.vue
// module id = 626
// module chunks = 30